import { jsx } from "react/jsx-runtime";
const DefaultShapeIndicatorErrorFallback = () => {
  return /* @__PURE__ */ jsx("circle", { cx: 4, cy: 4, r: 8, strokeWidth: "1", stroke: "red" });
};
export {
  DefaultShapeIndicatorErrorFallback
};
//# sourceMappingURL=DefaultShapeIndicatorErrorFallback.mjs.map
